interface IProps {
  color?: string;
  width?: string;
  viewBoxWidth?: number;
  viewBoxHeight?: number;
}
function RotateRightIcon({ color = '#d7d7d7', width = '40', viewBoxWidth = 100, viewBoxHeight = 70 }: IProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={width}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    >
      <path d="M37.242,2.971c14.689,0,27.651,8.476,33.688,21.325l4.201-8.719l5.298,2.552l-8.721,18.102L53.605,27.51l2.553-5.298   l9.43,4.542C60.494,15.964,49.594,8.853,37.242,8.853C19.95,8.853,5.88,22.921,5.88,40.214s14.07,31.362,31.362,31.362   c10.183,0,19.769-4.975,25.647-13.307l4.805,3.391c-6.979,9.892-18.361,15.797-30.452,15.797C16.707,77.458,0,60.75,0,40.214   S16.707,2.971,37.242,2.971z" />
    </svg>
  );
}

export default RotateRightIcon;
